import { render, staticRenderFns } from "./VlIndexSelectedDossiers.vue?vue&type=template&id=ebbd8bce&scoped=true&"
import script from "./VlIndexSelectedDossiers.vue?vue&type=script&lang=js&"
export * from "./VlIndexSelectedDossiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbd8bce",
  null
  
)

export default component.exports